<app-context-menu right="0" left="auto">

  <app-icon class="text-24" role="anchor" name="more-horizontal"></app-icon>

  <app-context-menu-item [routerLink]="['/settings/data-management']" class="is-right">

    <app-text [text]="'common-app.__DOWNLOAD_DATA' | AsyncLang | async"></app-text>

  </app-context-menu-item>

</app-context-menu>
